import { render, staticRenderFns } from "./NCLDC2026.vue?vue&type=template&id=aa037e12&scoped=true"
import script from "./NCLDC2026.vue?vue&type=script&lang=js"
export * from "./NCLDC2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa037e12",
  null
  
)

export default component.exports